import * as yup from 'yup';

export const addPositioningForm = yup.object().shape({
  customerId: yup.mixed().required('positioningForm.customerId.required'),
  realEstateId: yup
    .string()
    .required('positioningForm.searchCustomer.errorRequired'),
});
